import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ChannelProfile} from "../../../shared/interfaces";
import {ChannelService} from "../../../shared/services/channel.service";
import {Subscription, from} from "rxjs";
import {PaymentBuyCodeModalComponent}  from '../../../shared/components/payment-buy-code-modal/payment-buy-code-modal.component';
import {switchMap, map, delay} from 'rxjs/operators';
//import {NbToastrService, NbGlobalPosition } from '@nebular/theme';
import {ActivatedRoute, Params, Router} from '@angular/router';
 
import {  NbDialogService  } from '@nebular/theme';

@Component({ 
  selector: 'app-channel-page', 
  templateUrl: './channel-page.component.html',
  styleUrls: ['./channel-page.component.scss'],
   
})
export class ChannelPageComponent implements OnInit, OnDestroy, AfterViewInit{
 
   fragmentSub:any;	
   lSub$:any;
 sSub$:Subscription;
   searchText: string = ''
   loading:boolean = true
   channel: ChannelProfile;
   isEmbedChannel:boolean = false
   loaded:boolean = false

   ancorPlaylistSubpath = null

   tabs = {
    streams: 1,
    videos: 2,
    anonces: 3,
    playlists: 4,
  }
   
  currentTab: number 
  currentPlaylist = null
  liveIds = []
	//liveIds.indexOf(strm._id.toString()) !== -1

  constructor(
	private channelService: ChannelService,
	    private router: Router,
    public route:  ActivatedRoute,
     private dialogService: NbDialogService,
  ){
 
	 this.currentTab = <number>this.tabs.streams;


	let fragmentSub = this.route.fragment.subscribe(fr => {
  
	

		if(!fr){
		
			return

		}

		let path = fr.split('/')
			
		let fragment = path[0]
		//console.log(fragment)


		if(fragment === 'videos'){  this.currentTab = <number>this.tabs.videos; } 
		else  if(fragment === 'anonces'){  this.currentTab = <number>this.tabs.anonces; } 
		else  if(fragment === 'playlists'){  

			this.currentTab = <number>this.tabs.playlists; 

			if(path[1]) 
			this.ancorPlaylistSubpath = path[1]

		 } 

		 setTimeout(()=>{fragmentSub.unsubscribe();	},0)

	 });
  }
   

   ngOnInit() { 
	 	this.loading = true


		
		 

	this.lSub$ = this.route.params.pipe(
	      switchMap((params: Params)=>{
  		
			return this.channelService.getByUrl(params['url']).pipe(
		  map((channel: ChannelProfile)=>{
			//console.log(channel)

			if(!channel.url){
		 		this.router.navigate(['/channel'])
				return
			}
		    this.channel = channel


			this.liveIds = channel.liveIds
					
			if(this.ancorPlaylistSubpath)
			 this.currentPlaylist = this.channel.playlists.find(p => p._id === this.ancorPlaylistSubpath)
				

			var sbs$ = this.route.queryParams.subscribe((p: any)=>{
			    
				 if(p['embed-channel'] === "true"){  this.isEmbedChannel = true } 
				this.loaded = true
			    	this.loading = false


				setTimeout(()=>{ sbs$.unsubscribe(); },1)
			})

		    return channel
		  })
		)
	      })
    	).subscribe()

	
  }



  setSelectedPlaylist(playlist){

	this.currentPlaylist = playlist || null

		if(this.currentPlaylist){
			this.setAncor(`playlists/${this.currentPlaylist._id}`)
		}

  }


    onSearch(text){
	 
	

	if(!text){
		this.search(false)
	}else{
		this.search(text)

	}

  }


  setAncor(ancor){
   


	if(ancor === 'playlists' && this.currentPlaylist){ 
   	  window.location.hash=ancor + '/' + this.currentPlaylist._id
	} else {
	  window.location.hash=ancor
	}

  }
     

  onCancelSearch(){
	this.searchText = ''
	this.search(false)
  }

 
 

   search(text){
	if(this.sSub$){
	  this.sSub$.unsubscribe()
	}
 
	this.loading = true

	this.sSub$ = this.channelService.viewChannelsSearchInner(this.channel.url, text).subscribe((data:any)=>{
		 this.channel.streams = <any>data?.streams
		this.channel.videos = <any>data?.videos  
		//this.channel.videos = <any>data?.videos  
		this.liveIds = data.liveIds
	},(r)=>{   }, ()=>{this.loading = false;  this.searchText = text})

   }


  openWatch(item){


	let params = {  queryParams:{v: item.publicIdentity}}
	//isEmbedChannel 

		
	if(this.isEmbedChannel){   params.queryParams['embed-channel'] = 'true' }

	this.router.navigate(['/watch' ],params)

  }

 



  buyNowKey(e, stream){

		e.stopPropagation()

		 this.dialogService.open(PaymentBuyCodeModalComponent, {
			       
			      context: { 
				stream
			      },

				
			     closeOnEsc: false,
				closeOnBackdropClick: false
			    });

  } 




  buyNowPlaylist(e, playlist){

		e.stopPropagation()

		 this.dialogService.open(PaymentBuyCodeModalComponent, {
			       
			      context: { 
				playlist,
				isPlaylist: true
			      },

				
			     closeOnEsc: false,
				closeOnBackdropClick: false
			    });

  } 
   ngAfterViewInit() {
 
   }
 
   ngOnDestroy() {
   	if(this.lSub$){
	  this.lSub$.unsubscribe()
	}

	if(this.sSub$){
	  this.sSub$.unsubscribe()
	}

	
   }
  
}
